import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../../src/config";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify"; //. added
import "react-toastify/dist/ReactToastify.css"; //. added



const BasicInfo = forwardRef((props, ref) => {
  const location = useLocation();
  const { addnewproperties } = location.state || {}; // fallback if no state
  const params = new URLSearchParams(location.search);
  const stId = params.get("id") || "";

  //   useEffect(() => {
  //  console.log('addnewproperties:', addnewproperties);
  //     if (addnewproperties) {
  //       localStorage.removeItem("stayId");
  //     } else if(localStorage.getItem("stayId")){
  //       localStorage.setItem("stayId", stId);
  //     }
  //    console.log('localstorage stayId:', localStorage.getItem("stayId") );
  //   }, [addnewproperties]);

  //  useEffect(() => {
  //   const addNew =
  //     addnewproperties || localStorage.getItem("addnewproperties") === "true";
  //   console.log("addnewproperties:", addNew);
  //   console.log("URL stayId param:", stId);

  //   if (addNew) {
  //     if (!localStorage.getItem("stayId")) {
  //       // Only clear stayId the FIRST time
  //       localStorage.removeItem("stayId");
  //       localStorage.setItem("addnewproperties", "true");
  //       console.log("🆕 New property creation — stayId cleared.");
  //     } else {
  //       console.log("🟡 Add new mode but stayId already exists — not clearing again.");
  //     }
  //   } else if (stId) {
  //     localStorage.setItem("stayId", stId);
  //     console.log("stayId set from URL param:", stId);
  //   } else if (localStorage.getItem("stayId")) {
  //     console.log(
  //       "Using existing stayId from localStorage:",
  //       localStorage.getItem("stayId")
  //     );
  //   } else {
  //     localStorage.removeItem("stayId");
  //     console.log("No stayId available — localStorage cleared.");
  //   }

  //   console.log("Final stayId in localStorage:", localStorage.getItem("stayId"));
  // }, [addnewproperties, stId]);
  // const parseArray = (value) => {
  //   if (!value) return [""];
  //   if (Array.isArray(value)) return value;
  //   return value.split(",").map(v => v.trim());
  // };

  const parseArray = (value) => {
    if (!value) return [""];
    if (Array.isArray(value)) return value;
    return value.split(","); // ❗ removed trim
  };


  useEffect(() => {
    const addNew =
      addnewproperties || localStorage.getItem("addnewproperties") === "true";
    console.log("Add New Property Mode:", addNew);
    console.log("URL stayId param:", stId);

    if (addNew) {
      // User is adding a new property
      console.log("🆕 New property creation started.");
      localStorage.setItem("addnewproperties", "true");

      if (stId) {
        // If stId exists in URL, update it
        localStorage.setItem("stayId", stId);
        console.log("stayId updated from URL param:", stId);
      } else {
        // Otherwise clear any old stayId
        localStorage.removeItem("stayId");
        console.log("No stayId in URL — cleared localStorage stayId.");
      }
    } else {
      // User is editing or continuing an existing property
      localStorage.removeItem("addnewproperties");

      if (stId) {
        // stayId passed in URL → update localStorage
        localStorage.setItem("stayId", stId);
        console.log("stayId set from URL param:", stId);
      } else if (localStorage.getItem("stayId")) {
        console.log("Using existing stayId:", localStorage.getItem("stayId"));
      } else {
        console.log("No stayId found — nothing to load yet.");
      }
    }

    console.log("Final stayId in localStorage:", localStorage.getItem("stayId"));
  }, [addnewproperties, stId]);


  const [formData, setFormData] = useState({
    propertyName: "",
    // price_per_night: "",
    propertyAgeRange: "",
    acceptingBookingSince: 2024,
    hostLiveHere: false,
    hostedType: "",
    propertyType: "",
    pincode: "",
    contactNumber: "",
    email: "",
    firstName: "",
    lastName: "",
    gender: "",
    description: "",
    activities: "",
  });

  const [errors, setErrors] = useState({});

  const cleanValue = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "0" ||
      value === "null" ||
      value === "undefined" ||
      value === "na" ||
      value === "NA"
    ) {
      return "";
    }
    return value;
  };
  // Fetch stay & user details
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("accessToken") || "";
        const res = await axios.get(`${API_BASE_URL}auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data.success && res.data.data) {
          const user = res.data.data;
          setFormData((prev) => ({
            ...prev,
            firstName: user.firstname || prev.firstName,
            lastName: user.lastname || prev.lastName,
            email: user.email || prev.email,
            contactNumber: user.phone || prev.contactNumber,
          }));
        }
      } catch (err) {
        console.error("Error fetching user details:", err);
      }
    };

    const fetchStayDetails = async () => {
      const stayId = localStorage.getItem("stayId");
      if (stayId) {
        try {
          const token = localStorage.getItem("accessToken") || "";
          const res = await axios.post(
            `${API_BASE_URL}stays/details`,
            { id: stayId },
            { headers: { Authorization: `Bearer ${token}` } }
          );

          if (res.data.success && res.data.data) {
            const data = res.data.data;
            setFormData((prev) => ({
              ...prev,
              propertyName: data.title || prev.propertyName,
              // price_per_night: data.price_per_night || prev.price_per_night,
              propertyAgeRange: data.property_age_range || prev.propertyAgeRange,
              acceptingBookingSince:
                data.accepting_booking_since || prev.acceptingBookingSince,
              hostLiveHere: data.host_live_here ?? prev.hostLiveHere,
              hostedType: data.hosted_type || prev.hostedType,
              propertyType: data.property_type || prev.propertyType,
              //  pincode: data.pincode || prev.pincode,
              //   contactNumber: data.contact_number || prev.contactNumber,
              // email: data.email || prev.email,
              // firstName: data.owner?.firstname || prev.firstName,
              // lastName: data.owner?.lastname || prev.lastName,
              // gender: data.owner?.gender || prev.gender,
              // description: data.description || prev.description,
              description: cleanValue(data.description),
              activities: data.activities || "",
            }));
          }
        } catch (err) {
          console.error("Error fetching stay details:", err);
        }
      }
    };

    fetchStayDetails();
    fetchUserDetails();
  }, []);

  // Handle field change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "radio" ? value : type === "checkbox" ? checked : value,
    });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // Validate required fields
  const validateForm = () => {
    const newErrors = {};
    if (!formData.propertyName.trim())
      newErrors.propertyName = "Property name is required.";
    if (!formData.propertyAgeRange) newErrors.propertyAgeRange = "Property age is required.";
    // if(!formData.price_per_night || isNaN(formData.price_per_night) || Number(formData.price_per_night) <= 0) newErrors.price_per_night = "Valid price per night is required.";
    if (!formData.acceptingBookingSince)
      newErrors.acceptingBookingSince = "Booking start year required.";
    // if (!formData.pincode.trim()) newErrors.pincode = "Pincode is required.";
    if (!formData.contactNumber.trim())
      newErrors.contactNumber = "Contact number is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    // if (!formData.firstName.trim())
    //   newErrors.firstName = "First name is required.";
    // if (!formData.lastName.trim())
    //   newErrors.lastName = "Last name is required.";
    // if (!formData.gender) newErrors.gender = "Please select gender.";
    if (!formData.hostedType)
      newErrors.hostedType = "Please select a hosted type.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit handler
  const handleSubmit = async () => {
    if (!validateForm()) {
      const allErrors = Object.values(errors)
        .filter(msg => msg !== "")
        .join("\n");

      toast.warn(allErrors || "Please fill all fields.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });

      return false;
    }


    try {
      const token = localStorage.getItem("accessToken") || "";
      const stayId = localStorage.getItem("stayId") || undefined;
      const payload = { ...formData, ...(stayId && { stayId }) };
      console.log("Submitting payload:", payload);

      const res = await axios.post(`${API_BASE_URL}stays/basic-info`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("Response:", res.data);

      if (res.data.stay?.id) {
        toast.success("Basic info saved successfully!", {
          position: "top-right",
          autoClose: 2000,
          theme: "colored",
        });

        localStorage.setItem("stayId", res.data.stay.id);
        return res.data.stay.id;
      } else {
        toast.warn("Failed to get stayId from response.", {
          position: "top-right",
          autoClose: 2000,
        });
        return false;
      }
    } catch (err) {
      console.error("Error saving basic info:", err);
      toast.error("Failed to save basic info!", {
        position: "top-right",
        autoClose: 2000,
      });
      return false;
    }
  };

  useImperativeHandle(ref, () => ({
    submit: handleSubmit,
  }));

  const handleAddItem = (field) => {
    const arr = parseArray(formData[field]);
    arr.push("");
    setFormData({
      ...formData,
      [field]: arr.join(","),
    });
  };

  const handleRemoveItem = (field, idx) => {
    const arr = parseArray(formData[field]).filter((_, i) => i !== idx);
    setFormData({
      ...formData,
      [field]: arr.join(","),
    });
  };

  const handleItemChange = (field, idx, value) => {
    const arr = parseArray(formData[field]);
    arr[idx] = value;
    setFormData({
      ...formData,
      [field]: arr.join(","),
    });
  };


  return (
    <div className="tab-pane fade show active" role="tabpanel">
      <div className="row">
        <div className="col-12">
          <div className="basicinfodltheadingouter">
            <div className="dltheading">
              <h2>Basic Info</h2>
            </div>
          </div>

          <h3>Property Details</h3>
          <div className="row gx-3 gx-lg-4">
            {/* Property Name */}
            <div className="col-md-6">
              <div className="form-group">
                <label>Name of the property</label>
                <div className="formgroupinner">
                  <input
                    type="text"
                    className="form-control"
                    name="propertyName"
                    value={formData.propertyName}
                    onChange={handleChange}
                    placeholder="Property Name"
                  />
                  <i className="icon icon-underline-pencil"></i>
                </div>
                {errors.propertyName && (
                  <small className="text-danger">{errors.propertyName}</small>
                )}
              </div>
            </div>

            {/* Property Age */}
            <div className="col-md-6">
              <div className="form-group">
                <label>How old is the property?</label>
                <div className="formgroupinner">
                  <select
                    className="form-select"
                    name="propertyAgeRange"
                    value={formData.propertyAgeRange}
                    onChange={handleChange}
                  >
                    <option value="" hidden>Select</option>
                    <option value="0-5">0 - 5 years</option>
                    <option value="5-10">5 - 10 years</option>
                    <option value="10-15">10 - 15 years</option>
                    <option value="15-20">15 - 20 years</option>
                    <option value="20+">20+ years</option>
                  </select>
                </div>
                {errors.propertyAgeRange && (
                  <small className="text-danger">{errors.propertyAgeRange}</small>
                )}
              </div>
            </div>
            {/* Price per night 
                  */}
            {/* <div className="col-md-6">
              <div className="form-group">
                <label>Price per night</label>
                <div className="formgroupinner">
                  <input
                    type="text"
                    className="form-control"
                    name="price_per_night"
                    value={formData.price_per_night}
                    onChange={handleChange}
                    placeholder="Price per night"
                  />
                </div>
                {errors.price_per_night && (
                  <small className="text-danger">{errors.price_per_night}</small>
                )}
              </div>
            </div> */}

            {/* Booking Since + Live Here */}
            <div className="col-md-6">
              <div className="form-group">
                <label>Accepting booking since?</label>
                <div className="formgroupinner">
                  <select
                    className="form-select"
                    name="acceptingBookingSince"
                    value={formData.acceptingBookingSince}
                    onChange={handleChange}
                  >
                    <option hidden>Select a year</option>
                    {Array.from({ length: 2026 - 2000 + 1 }, (_, i) => 2026 - i).map((y) => (
                      <option key={y}>{y}</option>
                    ))}
                  </select>
                </div>
                {errors.acceptingBookingSince && (
                  <small className="text-danger">
                    {errors.acceptingBookingSince}
                  </small>
                )}
              </div>

              <div className="form-group">
                <label>Do you (host) live at this property?</label>
                <div className="d-flex gap-3">
                  <div className="form-check mt-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hostLiveHere"
                      value="false"
                      checked={!formData.hostLiveHere}
                      onChange={() =>
                        setFormData({ ...formData, hostLiveHere: false })
                      }
                    />
                    <label className="form-check-label">No</label>
                  </div>
                  <div className="form-check mt-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hostLiveHere"
                      value="true"
                      checked={formData.hostLiveHere}
                      onChange={() =>
                        setFormData({ ...formData, hostLiveHere: true })
                      }
                    />
                    <label className="form-check-label">Yes</label>
                  </div>
                </div>
              </div>
            </div>

            {/* Hosted Type */}
            <div className="col-md-6">
              <div className="form-group">
                <label>How will this property be hosted?</label>
                <div className="form-check align-items-start mt-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hostedType"
                    value="individual"
                    checked={formData.hostedType === "individual"}
                    onChange={handleChange}
                  />
                  <label className="form-check-label">
                    Individually
                    <span>
                      If hosting isn't your primary profession or income source
                    </span>
                  </label>
                </div>
                {/* Price per night 
                  */}
                {/* <div className="col-md-6">
              <div className="form-group">
                <label>Price per night</label>
                <div className="formgroupinner">
                  <input
                    type="text"
                    className="form-control"
                    name="price_per_night"
                    value={formData.price_per_night}
                    onChange={handleChange}
                    placeholder="Price per night"
                  />
                </div>
                {errors.price_per_night && (
                  <small className="text-danger">{errors.price_per_night}</small>
                )}
              </div>
            </div> */}


                <div className="form-check align-items-start mt-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hostedType"
                    value="business"
                    checked={formData.hostedType === "business"}
                    onChange={handleChange}
                  />
                  <label className="form-check-label">
                    As part of a business
                    <span>
                      If you're affiliated with a registered hospitality or
                      property management company
                    </span>
                  </label>
                </div>
                {errors.hostedType && (
                  <small className="text-danger">{errors.hostedType}</small>
                )}
              </div>
            </div>

            {/* Pincode */}
            <div className="col-md-6">
              <div className="form-group">
                <label>Pincode</label>
                <div className="formgroupinner">
                  <input
                    type="text"
                    className="form-control"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    placeholder="Pincode"
                  />
                </div>
                {errors.pincode && (
                  <small className="text-danger">{errors.pincode}</small>
                )}
              </div>
            </div>

            {/* Mobile */}
            <div className="col-md-6">
              <div className="form-group">
                <label>Mobile Number</label>
                <div className="formgroupinner">
                  <input
                    type="text"
                    className="form-control"
                    name="contactNumber"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    placeholder="Mobile Number"
                    readOnly
                  />
                  {/* <button className="verifybtn" type="button">
                    Verify
                  </button> */}
                </div>
                {errors.contactNumber && (
                  <small className="text-danger">{errors.contactNumber}</small>
                )}
              </div>
            </div>

            {/* Email */}
            <div className="col-md-6">
              <div className="form-group">
                <label>Email Id</label>
                <div className="formgroupinner">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email Id"
                    readOnly
                  />
                  {/* <button className="verifybtn" type="button">
                    Verify
                  </button> */}
                </div>
                {errors.email && (
                  <small className="text-danger">{errors.email}</small>
                )}
              </div>
            </div>

            {/* Property Type */}
            <div className="col-md-6">
              <div className="form-group">
                <label>Property Type</label>
                <div className="formgroupinner">
                  <select
                    className="form-select"
                    name="propertyType"
                    value={formData.propertyType}
                    onChange={handleChange}
                  >
                    <option value="" hidden>Select</option>
                    <option value="heritage">Heritage Homestays</option>
                    <option value="eco_farmstay">Eco-Stays/Farmstays</option>
                    <option value="tea_garden_estate">Tea Garden Estates</option>
                    <option value="wilderness_ecostay">Wilderness Ecostay</option>
                    <option value="jungle_camp">Jungle Camp</option>
                    <option value="riverside">Riverside</option>
                  </select>
                </div>
                {errors.propertyType && (
                  <small className="text-danger">{errors.propertyType}</small>
                )}
              </div>
            </div>

            {/* Personal Details */}
            {/* <div className="col-12">
              <h3 className="mb-1">Personal Details</h3>
              <p>
                This will show in the 'Host Profile' of all the properties where
                you are the host on Guestlinkup Website/App
              </p>
            </div> */}

            {/* First Name */}
            {/* <div className="col-md-6">
              <div className="form-group">
                <label>First Name</label>
                <div className="formgroupinner">
                  <input
                    type="text"
                    className="form-control"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="First Name"
                  />
                </div>
                {errors.firstName && (
                  <small className="text-danger">{errors.firstName}</small>
                )}
              </div>
            </div> */}

            {/* Last Name */}
            {/* <div className="col-md-6">
              <div className="form-group">
                <label>Last Name</label>
                <div className="formgroupinner">
                  <input
                    type="text"
                    className="form-control"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Last Name"
                  />
                </div>
                {errors.lastName && (
                  <small className="text-danger">{errors.lastName}</small>
                )}
              </div>
            </div> */}

            {/* Gender */}
            {/* <div className="col-md-6">
              <div className="form-group">
                <label>Gender</label>
                <div className="d-flex gap-3">
                  <div className="form-check mt-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      value="Male"
                      checked={formData.gender === "Male"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">Male</label>
                  </div>
                  <div className="form-check mt-1">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      value="Female"
                      checked={formData.gender === "Female"}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">Female</label>
                  </div>
                </div>
                {errors.gender && (
                  <small className="text-danger">{errors.gender}</small>
                )}
              </div>
            </div> */}

            <div className="col-md-8">
              <div className="formgroupinner">
                <label>Activities</label>

                <div className="formgroupinner mt-3">
                  {parseArray(formData.activities).map((item, i) => (
                    <div
                      key={i}
                      style={{ display: "flex", gap: "8px", marginBottom: "8px" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g., Trekking"
                        value={item}
                        onChange={(e) =>
                          handleItemChange("activities", i, e.target.value)
                        }
                      />
                      <button
                        type="button"
                        onClick={() => handleRemoveItem("activities", i)}
                        className="btn btn-danger btn-sm"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <button
                type="button"
                className="theme-btn btn-sm"
                onClick={() => handleAddItem("activities")}
              >
                + Add Activity
              </button>
            </div>


            {/* Host Description */}
            <div className="col-12 mt-4">
              <div className="form-group">
                <label>Description About Property</label>
                <div className="formgroupinner">
                  <textarea
                    className="form-control"
                    placeholder="Enter details here..."
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
export default BasicInfo;
